import React, {useState, ChangeEvent }  from 'react';
import Training from "../../types/Training";
import TrainingPart from '../../types/TrainingPart';
import TimeEditor from "../TimeEditor";

type TrainingListPartItemProps = {
  training: Training;
  trainingPart: TrainingPart;
  updateTrainingPartHandler : (trainingPart2Update: TrainingPart) => void;
  removeTrainingPartHandler : (trainingPart2Remove : TrainingPart) => void;
};

type TrainingPartType = {
  id: string;
  desc: string;
  hrZone: string;
};

type TrainingPartTypeArray = readonly TrainingPartType[];

const trainingPartTypeRunningArray: TrainingPartTypeArray = [
  { id: 'WU_CD', desc: 'Warm Up/Cool down', hrZone: '0'},
  { id: 'BC', desc: 'Bieg ciągły', hrZone: '1' },
  { id: 'CROSS', desc: 'Cross', hrZone: '1' },
  { id: 'R', desc: 'Rytmy', hrZone: '3' },
  { id: 'POD', desc: 'Podbiegi', hrZone: '3' },
  { id: 'S', desc: 'Skipy', hrZone: '3' },
  { id: 'WB', desc: 'Wycieczka biegowa', hrZone: '0' },
  { id: 'ACT_REST', desc: 'Aktywny odpoczynek', hrZone: '0' }
] as const;

const trainingPartTypeAlternativeArray : TrainingPartTypeArray = [
  { id: 'POOL', desc: 'Basen', hrZone: '0' },
  { id: 'BICYCLE', desc: 'Rower', hrZone: '0' },
  { id: 'XCSKI', desc: 'Narty biegowe', hrZone: '0' },
  { id: 'XCSKICL', desc: 'Narty biegowe s. klasyczny', hrZone: '0' },
  { id: 'XCSKISK', desc: 'Narty biegowe s. łyżwowy', hrZone: '0' },
  { id: 'XCSKIERG', desc: 'SkiErg', hrZone: '1' },
  { id: 'CROSSTRAINER', desc: 'Cross trainer', hrZone: '1' }
] as const;

const trainingPartTypSupplementaryArray : TrainingPartTypeArray = [
  { id: 'BDIP', desc: 'Bez dystansu i przewyższenia', hrZone: '-' },
  { id: 'BERET', desc: 'Beret', hrZone: '-' },
  { id: 'SILA_STABILIZACJS_OG', desc: 'Siła/Stabilizacja ogólna', hrZone: '-' },
  { id: 'SILA_STABILIZACJA_NOGI', desc: 'Siła/Stabilizacja nogi', hrZone: '-' },
  { id: 'SPRAWNOSC_MOBILNOSC', desc: 'Sprawność/mobilność', hrZone: '-' },
  { id: 'WU_CD', desc: 'Warm Up/Cool down', hrZone: '0' },
  { id: 'ROLLING', desc: 'Rolowanie', hrZone: '-' },
  { id: 'STRETCHING', desc: 'Rozciąganie', hrZone: '-' }
] as const;

const trainingPartTypeSupplementaryTechArray : TrainingPartTypeArray = [
  { id: 'POOL', desc: 'Basen', hrZone: '0' },
  { id: 'BICYCLE', desc: 'Rower', hrZone: '0' },
  { id: 'XCSKICL', desc: 'Narty biegowe s. klasyczny', hrZone: '0' },
  { id: 'XCSKISK', desc: 'Narty biegowe s. łyżwowy', hrZone: '0' },
  { id: 'XCSKIERG', desc: 'SkiErg', hrZone: '1' },
  { id: 'CROSSTRAINER', desc: 'Cross trainer', hrZone: '1' }
] as const;

const trainingType2PartTypArray : Map<string, TrainingPartTypeArray> = new Map([
  ['RUNNING', trainingPartTypeRunningArray],
  ['ALTERNATIVE', trainingPartTypeAlternativeArray],
  ['SUPPLEMENTARY', trainingPartTypSupplementaryArray],
  ['SUPPLEMENTARY_TECHNICAL', trainingPartTypeSupplementaryTechArray]
]);

const trainingPartHRZoneArray : TrainingPartTypeArray = [
  { id: '-', desc: '-', hrZone: '-' },
  { id: 'G0', desc: 'G0' , hrZone: 'G0'},
  { id: 'G1', desc: 'G1' , hrZone: 'G1'},
  { id: 'G2', desc: 'G2' , hrZone: 'G2'}, 
  { id: 'G3', desc: 'G3' , hrZone: 'G3'},
  { id: '1', desc: '1' , hrZone: '1'},
  { id: '2', desc: '2' , hrZone: '2'},
  { id: '3', desc: '3' , hrZone: '3'},
  { id: '4', desc: '4' , hrZone: '4'},
  { id: '5', desc: '5' , hrZone: '5'},
  { id: '6', desc: '6' , hrZone: '6'},
  { id: 'Z', desc: 'Zawody' , hrZone: 'Z'} 
] as const;

const trainingPartTypeMapTypeArray : TrainingPartTypeArray = [
  { id: 'MAP', desc: 'Mapa' , hrZone: '-'},
  { id: 'MAP_SIMULATION', desc: 'Symulacja', hrZone: '-' },
  { id: 'NONE', desc: 'Brak', hrZone: '-' }
] as const;

function TrainingListItem(props : TrainingListPartItemProps) {
   

    const [trainingPartData, setTrainingPartData] = useState(props.trainingPart);
 
    function handleClickDelete() {
       props.removeTrainingPartHandler(trainingPartData);
    };

    const handleChangePartTime = (newInputSeconds : number) => {
      let newTrainingPartData : TrainingPart = { ...trainingPartData, partTime: newInputSeconds };
      setTrainingPartData(newTrainingPartData);
      props.updateTrainingPartHandler(newTrainingPartData);

    };

    const handleSelectableChandle = (event: ChangeEvent<HTMLSelectElement>) => {
      const { id, value } = event.target;
    
      let newTrainingPartData: TrainingPart = { ...trainingPartData, [id]: value };
    
      if (id === 'partType' && partTypeArray) {
        // Find the matching partType to get its default hrZone
        const selectedPartType = partTypeArray.find((item) => item.id === value);
        if (selectedPartType) {
          newTrainingPartData.hrZone = selectedPartType.hrZone;
        }
      }
    
      setTrainingPartData(newTrainingPartData);
      props.updateTrainingPartHandler(newTrainingPartData);
    };

    let partTypeArray : TrainingPartTypeArray | undefined = trainingType2PartTypArray.get(props.training.trainingType);

    return (
        <tr id={"TRP_" + trainingPartData.id}>
            <td><select id="partType" className="form-select" value={trainingPartData.partType} onChange={handleSelectableChandle}>
                    { partTypeArray  && partTypeArray.map((value) => <option key={value.id} value={value.id}>{value.desc}</option>)  }
                </select>
            </td>
            <td>
              <TimeEditor
                initialValue={trainingPartData.partTime} // Initial value in seconds
                onChange={handleChangePartTime} // Update handler
              />
            </td>
            <td>
                <select id="hrZone" className="form-select" value={trainingPartData.hrZone} onChange={handleSelectableChandle}>
                  { trainingPartHRZoneArray.map((value) => <option key={value.id} value={value.id}>{value.desc}</option>) }
                </select>
            </td>
            <td>
                <select id="mapType" className="form-select" value={trainingPartData.mapType} onChange={handleSelectableChandle}>
                  { trainingPartTypeMapTypeArray.map((value) => <option key={value.id} value={value.id}>{value.desc}</option>) }                  
                </select>
                </td>
            <td>
                <button type="button" className="btn btn-danger" onClick={() => handleClickDelete()}>Usuń</button>
            </td>
        </tr>
    );
}

export default TrainingListItem;
